import { setupCxgenie } from './cxgenie'
import { setupLivechat } from './livechat'
import { setupSalesmartly } from './salesmartly'
import { setupTawk } from './tawk'

import { useNuxtApp } from '#app'
import { isTrue } from '@/utils/siteConfigChecker'

export function getContext() {
  if (!import.meta.client) return null

  const nuxtApp = useNuxtApp()
  if (!nuxtApp._customerServiceContext) {
    nuxtApp._customerServiceContext = {
      initializedServices: new Set(),
      livechatService: null,
      tawkService: null,
      salesmartlyService: null,
      cxgenieService: null,
    }
  }
  return nuxtApp._customerServiceContext
}

const setupHandlers = {
  livechat: (item, _locale, _ctx) => setupLivechat(item),
  tawk: (item, _locale, ctx) => setupTawk(item, ctx),
  salesmartly: (item) => setupSalesmartly(item),
  cxgenie: (item, locale) => setupCxgenie(item, locale),
}

const serviceKeys = {
  livechat: 'livechatService',
  tawk: 'tawkService',
  salesmartly: 'salesmartlyService',
  cxgenie: 'cxgenieService',
}

function setUp({ csChat = [], locale = 'en' }) {
  if (!import.meta.client) return

  const ctx = getContext()
  if (!ctx) return

  csChat.forEach((item) => {
    if (!isTrue(item.enable) || ctx.initializedServices.has(item.name)) {
      return
    }

    const handler = setupHandlers[item.name]
    const key = serviceKeys[item.name]
    if (handler && key) {
      const service = handler(item, locale, ctx)
      if (service) {
        ctx[key] = service
      } else {
        return
      }
    }

    ctx.initializedServices.add(item.name)
  })
}

function doAction(csItem, action, param) {
  if (!import.meta.client) return

  const ctx = getContext()
  if (!ctx) return

  const { name, link } = csItem || {}
  switch (name) {
    case 'livechat':
      if (ctx.livechatService) {
        ctx.livechatService[action]?.call(ctx.livechatService, param)
      }
      break
    case 'tawk':
      if (ctx.tawkService?.loaded) {
        ctx.tawkService[action].call(ctx.tawkService, param)
      }
      break
    case 'salesmartly':
      if (ctx.salesmartlyService) {
        ctx.salesmartlyService[action]?.call(ctx.salesmartlyService, param)
      }
      break
    case 'cxgenie':
      if (ctx.cxgenieService) {
        ctx.cxgenieService[action]?.call(ctx.cxgenieService, param)
      }
      break
    case 'telegram':
      if (action === 'maximize') {
        window.open(link)
      }
      break
    case 'line':
      if (action === 'maximize') {
        window.open(link)
      }
      break
    case 'all':
      if (action === 'minimize' || action === 'hide') {
        if (ctx.livechatService) {
          ctx.livechatService[action].call(ctx.livechatService)
        }
        if (ctx.tawkService) {
          ctx.tawkService[action].call(ctx.tawkService)
        }
        if (ctx.salesmartlyService) {
          ctx.salesmartlyService[action].call(ctx.salesmartlyService)
        }
        if (ctx.cxgenieService) {
          ctx.cxgenieService[action].call(ctx.cxgenieService)
        }
      }
      break
    default:
      console.log('Unknown customer service !!', name)
      break
  }
}

export default { setUp, doAction }
